/**
 * normalizeTimestamp — convertit un timestamp hétérogène en Date JS valide.
 *
 * Les endpoints Revyo retournent `review_time` (ou champs date) sous 3 formes :
 *   - string ISO 8601 : "2026-04-12T10:30:00.000Z"
 *   - bigint/number Unix seconds : 1712928000
 *   - bigint/number Unix ms : 1712928000000
 *
 * Heuristique seuils → ms : valeur < 1e11  =>  secondes (× 1000)
 *                       valeur >= 1e11 =>  millisecondes (laissée en l'état)
 * 1e11 ms = ~5 mars 1973 — toute date Google review postérieure passe le test.
 *
 * @param {string|number|bigint|Date|null|undefined} value
 * @returns {Date|null} Date valide, ou null si non parsable / vide.
 */
export function normalizeTimestamp(value) {
  if (value === null || value === undefined || value === '') return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (typeof value === 'number' || typeof value === 'bigint') {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return null;
    const ms = n < 1e11 ? n * 1000 : n;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  return null;
}

/**
 * normalizeTimestampISO — variante qui retourne un ISO string ou null.
 * Utile pour les composants qui veulent une string stable (ex: clé React).
 *
 * @param {string|number|bigint|Date|null|undefined} value
 * @returns {string|null}
 */
export function normalizeTimestampISO(value) {
  const d = normalizeTimestamp(value);
  return d ? d.toISOString() : null;
}
